import { ApiFetcherResponse } from "../../api/common/useAuthenticatedFetcher";
import { errorToast, successToast } from "../../toast";
import AddRequiredEvidenceTypeForm from "../AddRequiredEvidenceTypeForm";
import { AddRequiredEvidenceTypeFormValues } from "../AddRequiredEvidenceTypeForm/AddRequiredEvidenceTypeFormValues";
import DialogBox from "../DialogBox";

export type AddRequiredEvidenceDialogProps = {
    isOpen: boolean;
    onClose: (evidenceSubmitted: boolean) => void;
    request: (
        value: AddRequiredEvidenceTypeFormValues
    ) => Promise<ApiFetcherResponse<void>>;
    isSubmitting: boolean;
    requiredEvidenceTypes: number[];
};

const AddRequiredEvidenceDialog = ({
    isOpen,
    onClose,
    request,
    isSubmitting,
    requiredEvidenceTypes,
}: AddRequiredEvidenceDialogProps) => {
    const handleAddRequiredEvidenceFormSubmission = async (
        evidenceTypeId: number
    ) => {
        const dto = {
            evidenceTypeId: evidenceTypeId,
        };

        const response = await request(dto);

        if (!response.success) {
            errorToast(
                "There was a problem adding the required evidence type - please try again"
            );
            return;
        }

        successToast("Required evidence type added");
        onClose(true);
    };

    return (
        <DialogBox
            title="Add required evidence type"
            isOpen={isOpen}
            onClose={() => onClose(false)}
            className="max-w-lg"
        >
            <AddRequiredEvidenceTypeForm
                isLoading={isSubmitting}
                onSubmit={handleAddRequiredEvidenceFormSubmission}
                onCancel={() => onClose(false)}
                requiredEvidenceTypesIds={requiredEvidenceTypes}
            />
        </DialogBox>
    );
};

export default AddRequiredEvidenceDialog;
